<template>
  <u-deploy-panel>
    <template slot="title">
      {{ $t('title') }}
    </template>
    <template slot="content">
      <p>{{ $t('headline') }}</p>
      <p>{{ $t('content') }}</p>
    </template>
    <template slot="actions">
      <a :href="learnMore" target="_blank">
        <v-btn text>{{ $t('learn_more') }}</v-btn>
      </a>
      <v-spacer />
      <v-btn text @click="$emit('cancel')">{{ $t('wizard.cancel') }}</v-btn>
      <v-btn v-if="newDeployment" text @click="$emit('prev')">{{ $t('wizard.prev') }}</v-btn>
      <v-btn color="primary" @click="$emit('next')">{{ $t('wizard.start') }}</v-btn>
    </template>
  </u-deploy-panel>
</template>

<script>
import DeployPanelComponent from '@/components/deploy/Panel.vue'
import { docsUrl } from '@/services/docs'

export default {
  data () {
    return {
      docs: docsUrl('manage'),
      learnMore: docsUrl('quickstart')
    }
  },
  props: {
    newDeployment: false
  },
  components: {
    'u-deploy-panel': DeployPanelComponent
  }
}
</script>

<i18n>
{
  "en": {
    "learn_more": "Learn More",
    "title": "Add deployment",
    "headline": "This wizard guides you through creating a new deployment.",
    "content": "Deployments enable multi-tenant isolation, allowing you to separate and manage your Unryo systems independently."
  }
}
</i18n>
